import { useEffect, useRef, useState } from 'react';
import { profile, socials } from '../data/content';
import { SectionHead, SocialIcon } from './primitives';

export function Contact() {
  const [copied, setCopied] = useState(false);
  const timer = useRef<ReturnType<typeof setTimeout>>(undefined);

  useEffect(() => () => clearTimeout(timer.current), []);

  async function copyEmail() {
    try {
      await navigator.clipboard.writeText(profile.email);
      setCopied(true);
      clearTimeout(timer.current);
      timer.current = setTimeout(() => setCopied(false), 2000);
    } catch {
      // Clipboard is blocked over plain HTTP and in some locked-down browsers.
      // The mailto link still works, so fail quietly.
    }
  }

  return (
    <section className="section section--alt" id="contact" aria-labelledby="contact-title">
      <div className="container">
        <SectionHead title="Contact" id="contact-title" />

        <div data-reveal>
          <p className="lede">
            I am open to new-grad and entry-level software engineering roles, and happy to talk about
            backend, distributed systems, or infrastructure work. Email reaches me fastest.
          </p>

          <p>
            <a className="contact__mail" href={`mailto:${profile.email}`}>
              {profile.email}
            </a>
          </p>

          <div className="contact__actions">
            <button type="button" className="btn btn--solid" onClick={copyEmail}>
              {copied ? <span className="copied">Copied</span> : 'Copy email'}
            </button>
            <a className="btn btn--outline" href={profile.linkedin} target="_blank" rel="noreferrer">
              LinkedIn
            </a>
            <a className="btn btn--outline" href={profile.github} target="_blank" rel="noreferrer">
              GitHub
            </a>
          </div>

          <ul className="socials">
            {socials.map((social) => (
              <li key={social.id}>
                <a href={social.href} aria-label={social.label} rel="noreferrer">
                  <SocialIcon name={social.id} />
                </a>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
}
